<template>
  <el-dialog ref="dialog" v-model="visible" class="dialog" destroy-on-close :title="title" center width=600 show-close @close="handleClose">
    <el-alert title="密码修改成功后，您将被重定向到登录页面，需使用新密码重新登录。" type="info" show-icon style="margin-bottom: 15px;"/>
    <el-form ref="form" :model="form" :rules="rules" label-width="120px" style="margin-top:20px;">
        <el-form-item label="当前密码" prop="oldPassWord">
            <el-input v-model="form.oldPassWord" type="password" show-password placeholder="请输入当前密码"></el-input>
            <div class="el-form-item-msg">必须提供当前登录用户密码才能进行更改</div>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassWord">
            <el-input v-model="form.newPassWord" type="password" show-password placeholder="请输入新密码"></el-input>
            <v-password-strength v-model="form.newPassWord"></v-password-strength>
            <div class="el-form-item-msg">请输入包含英文、数字的8位以上密码</div>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmnewPassWord">
            <el-input v-model="form.confirmnewPassWord" type="password" show-password placeholder="请再次输入新密码"></el-input>
        </el-form-item>
        <div style="border-bottom: 1px solid #eee;" />
    </el-form>
    <template #footer>
      <el-button type="primary" @click="handleSave">修  改</el-button>
      <el-button @click="this.visible = false" >关  闭</el-button>
    </template>
  </el-dialog>
</template>

<script>
import vPasswordStrength from '@/components/vPasswordStrength'
import { changePsd } from '@/api/model/admin'
import { ElMessage, ElMessageBox } from 'element-plus'
import storage from '@/utils/storage'

export default {
    data() {
        return {
            visible: false,
            title:"",
            form:{
                oldPassWord: "",
                newPassWord: "",
                confirmnewPassWord: ""
            },
            rules: {
                oldPassWord: [
                    { required: true, message: '请输入当前密码'}
                ],
                newPassWord: [
                    { required: true, message: '请输入新密码'}
                ],
                confirmnewPassWord: [
                    { required: true, message: '请再次输入新密码'},
                    {validator: (rule, value, callback) => {
                        if (value !== this.form.newPassWord) {
                            callback(new Error('两次输入密码不一致'));
                        }else{
                            callback();
                        }
                    }}
                ]
            }
        }
    },
    methods:{
        open(){
            this.title = "修改用户密码"
            this.visible = true
        },
        handleClose(){
            Object.assign(this.$data, this.$options.data())
        },
        handleSave(){
            if(this.form.newPassWord != this.form.confirmnewPassWord){
                ElMessage({showClose: true, message: "两次密码输入不一致", type: 'error'})
                return
            }
            console.log(this.form);
            if(this.form.oldPassWord == "" || this.form.newPassWord == "" || this.form.confirmnewPassWord == ""){
                ElMessage({showClose: true, message: "所有字段都是必须的", type: 'error'})
                return
            }
            changePsd(this.form).then((res)=>{
                ElMessage({showClose: true, message: res.msg, type: 'success'})
                storage.remove("token");
                setTimeout(()=>{ this.$router.replace({ path: '/login' }) }, 100)
                this.handleClose()
            }).catch((err)=>{ })
        }
    },
    components: { vPasswordStrength }
}
</script>

<style>

</style>